module.exports = __webpack_public_path__ + "static/media/huegah.1ad48cf4.webp";